import { Stack, Typography, useTheme } from "@mui/material";
import { useAtomValue } from "jotai";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SettingsMenuSection } from "web_myplann/More/Components/SettingsMenuSection";
import { useSettingsMenuItems } from "web_myplann/More/Hooks/useSettingsMenuItems";
import { PaperworkOrigin } from "web_myplann/Profile/Types/PaperworkNavigationState";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { appInfoState } from "web_myplann/Shared/State/appInfoAtom";

export const MorePage = () => {
	const theme = useTheme();
	const { t } = useResource();
	const appInfoAtom = useAtomValue(appInfoState);
	const { toolItems, settingsItems } = useSettingsMenuItems(
		PaperworkOrigin.More,
	);

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<MyPlannNavigationHeader
					title={t(Resources.Settings.title)}
					bgColor={theme.palette.background.paper}
				/>
			}
		>
			<Stack minHeight="100%">
				<Typography variant="sectionLabel">
					{t(Resources.Settings.Sections.Tools)}
				</Typography>
				<SettingsMenuSection items={toolItems} />

				<Typography variant="sectionLabel">
					{t(Resources.Settings.Sections.Settings)}
				</Typography>
				<SettingsMenuSection items={settingsItems} />

				<Stack alignItems="center" py={theme.spacingTokens.xxl}>
					<Typography variant="hint">
						{`myPLANN ${appInfoAtom.appVersion}`}
					</Typography>
					<Typography variant="hint" mt={theme.spacingTokens.xs}>
						{t(Resources.Settings.Copyright)}
					</Typography>
				</Stack>
			</Stack>
		</MyPlannLayout>
	);
};
